import React, { createContext, useState } from 'react';


export const YearContext = createContext();

export const YearProvider = ({ children }) => {
    const [yearcurrent, setyearcurrent] = useState(new Date().getFullYear());

    return (
        <YearContext.Provider value={{ yearcurrent, setyearcurrent }}>
            {children}
        </YearContext.Provider>
    );
};
